import * as React           from 'react';

import { IconButton       } from 'src/components/common/icon-button';

import { Container,
         Label,
         LabelIcons,
         Asterisk,
         Optional,
         Component,
         LabeledVariants,
         labeled_variants } from 'src/components/common/labeled/ui';

import { voidFunction     } from 'src/common';



type Props = {
  variant: LabeledVariants;
  label: string;
  isRequired?: boolean;
  isOptional?: boolean;
  iconButtons?: { id: string; icon: React.ReactNode; }[];
  onIconButtonClick?: (id: string) => void;
  children: React.ReactNode;
}
export const Labeled: React.FC<Props> = ({
  variant,
  label,
  isRequired = false,
  isOptional = false,
  iconButtons = [],
  onIconButtonClick = voidFunction,
  children
}) => {
  const lookAndFeel = labeled_variants.get(variant)!;

  return (
    <Container lookAndFeel = { lookAndFeel }>
      <Label lookAndFeel = { lookAndFeel }>
        { label }
        { isRequired && (<Asterisk lookAndFeel = { lookAndFeel }>*</Asterisk>)}
        { isOptional && (<Optional lookAndFeel = { lookAndFeel }>(необязательно)</Optional>)}
        { iconButtons.length > 0 && (
          <LabelIcons lookAndFeel = { lookAndFeel }>
            {iconButtons.map((button) => (
              <IconButton
                variant = { lookAndFeel.labelIconButtonVariant }
                onTap = { () => onIconButtonClick(button.id) }
                isTapAllowed
              >
                { button.icon }
              </IconButton>
            ))}
          </LabelIcons>

        )}
      </Label>
      <Component lookAndFeel = { lookAndFeel }>{ children }</Component>
    </Container>
  );
};
